import { AnchorLink } from 'components/anchorLink';
import styles from './VirtualCompetitors.module.scss';

export type VirtualCompetitorsProps = {
  slug: string;
  className?: string;
  firstCompetitor?: string;
  secondCompetitor?: string;
  description?: string;
  firstAvvenimentoDescription?: string;
};

export const VirtualCompetitors = ({
  className,
  firstCompetitor,
  secondCompetitor,
  description,
  slug,
  firstAvvenimentoDescription,
}: VirtualCompetitorsProps) => {
  return (
    <AnchorLink
      className={`${styles.container} ${className ? className : ''} ${true ? styles.full : ''}`} // isFullWidth
      href={slug}
    >
      <ul className={`${styles.list} ${description ? styles.singleItem : ''}`}>
        {firstCompetitor && secondCompetitor && (
          <>
            <li className={styles.item}>
              <span className={styles.name}>{firstCompetitor}</span>
            </li>
            <li className={styles.item}>
              <span className={styles.name}>{secondCompetitor}</span>
            </li>
          </>
        )}
        {description && (
          <li className={`${styles.item} ${firstAvvenimentoDescription && styles.itemWithFistDescription}`}>
            <span className={styles.name}>{description}</span>
            {firstAvvenimentoDescription && <span>{firstAvvenimentoDescription}</span>}
          </li>
        )}
      </ul>
    </AnchorLink>
  );
};
